import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)
import appStoreModule from './app-store-module.js';
import authStoreModule from './auth-store-module.js';
const store = new Vuex.Store({
    modules: {
        app: appStoreModule,
        auth: authStoreModule
    }
});
export default store;